import {Setting} from "./Setting";

export const natureSetting: Setting = {
    key: "Nature",
    title: "Природа",
    description: "Природа описывает окружающую среду, климатические условия, флору и фауну, а также их взаимодействие с персонажами и обществом. Она создает атмосферу, формирует локации и может быть как союзником, так и препятствием для игрока.",
    components: [
        {
            title: "География и ландшафты",
            subComponents: [
                {
                    title: "Типы местности",
                    description: `Горы, равнины, холмы, долины. Леса, пустыни, болота, каньоны, пещеры, скалы. Берега, острова, архипелаги, коралловые рифы.`,
                    examples: ["Вулканические зоны, гейзеры, горячие источники."]
                },
                {
                    title: "Особенности",
                    description: `Магические или фантастические ландшафты, включая летающие острова, светящиеся деревья, кристальные поля.`,
                    examples: ["Леса с деревьями, которые поют."]
                }
            ]
        },
        {
            title: "Климат и погодные условия",
            subComponents: [
                {
                    title: "Типы климата",
                    description: `Умеренный, тропический, арктический, пустынный. Переменные зоны (сезонные изменения).`,
                    examples: ["Умеренный климат с четкими временами года."]
                },
                {
                    title: "Погодные явления",
                    description: `Явления погоды, встречающиеся в мире, включая обычные (дождь, снег, туман, ветер, штормы), экстремальные (ураганы, цунами, пыльные бури, лавины) и фантастические (магические бури, звездопады, энергетические вихри).`,
                    examples: ["Дождь, снег, туман, ветер, штормы", "Ураганы, цунами, пыльные бури, лавины", "магические бури, звездопады, энергетические вихри"]
                }
            ]
        },
        {
            title: "Растительность (Флора)",
            subComponents: [
                {
                    title: "Обычные растения",
                    description: `Травы, кустарники, деревья, цветы. Лекарственные и ядовитые растения.`,
                    examples: ["Дубы, ели, клевер, розы.", "Молочай, папоротник, плющ."]
                },
                {
                    title: "Фантастическая флора",
                    description: `Светящиеся деревья, разумные растения. Мутировавшая или магическая флора (ядовитые лозы, растения-ловушки).`,
                    examples: ["Деревья, которые питаются магией.", "Растения, которые атакуют животных."]
                }]
        },
        {
            title: "Животный мир (Фауна)",
            subComponents: [
                {
                    title: "Обычные животные",
                    description: `Хищники и травоядные, насекомые, рыбы, птицы. Домашние животные, скот.`,
                    examples: ["Волки, олени, лисы, вороны.", "Кошки, собаки, лошади."]
                },
                {
                    title: "Фантастические существа",
                    description: `Магические существа (грифоны, единороги, драконы). Гибриды животных (волкоптицы, ящеролисы).`,
                    examples: ["Грифон, дракон, единорог.", "Волк-паук, ящер-лиса."]
                },
                {
                    title: "Враждебные виды",
                    description: `Хищники, разумные существа, мутанты.`,
                    examples: ["Волк-оборотень, гоблин, зомби."]
                },
                {
                    title: "Поведение",
                    description: `Миграции, сезонная активность, взаимодействие с миром (охота, гнездование).`,
                    examples: ["Птицы, мигрирующие на юг зимой."]
                }]
        },
        {
            title: "Ресурсы природы",
            subComponents: [
                {
                    title: "Полезные ископаемые",
                    description: `Металлы, камень, драгоценности, уголь, нефть. Фантастические материалы (магические кристаллы, эфирный камень).`,
                    examples: ["Железо, золото, алмазы", "Магический кристалл, эфирный камень"]
                },
                {
                    title: "Растительные ресурсы",
                    description: `Древесина, травы, плоды, семена. Магические растения (цветы, которые лечат, или плоды, дающие силу).`,
                    examples: ["Дубовая древесина, лечебные травы", "Цветы, восстанавливающие ману"]
                },
                {
                    title: "Животные ресурсы",
                    description: `Шкуры, мясо, кости, магические органы. Приручаемые существа (транспорт, охрана, спутники).`,
                    examples: ["Мех, мясо, кости", "Летучая мышь, ведущая к ближайшему поселению"]
                }]
        },
        {
            title: "Взаимодействие природы и общества",
            subComponents: [
                {
                    title: "Использование природы",
                    description: `Земледелие, охота, рыболовство, собирательство. Заготовка леса, разработка месторождений.`,
                    examples: ["Поля для посева, ловушки для дичи", "Шахта, добывающая уголь"]
                },
                {
                    title: "Защита природы",
                    description: ` Святые рощи, заповедники, законы об охране природы. Друиды и защитники природных территорий.`,
                    examples: ["Лесной дух, охраняющий лес"]
                },
                {
                    title: "Угрозы природе",
                    description: `Загрязнение, чрезмерная добыча ресурсов, вырубка лесов. Магические катаклизмы, войны, разрушения.`,
                    examples: ["Лесной пожар, вызванный магическими существами"]
                }]
        },
        {
            title: "Особые природные зоны",
            subComponents: [
                {
                    title: "Священные места",
                    description: `Святые рощи, водоемы, вершины гор, пещеры. Локации, связанные с легендами и древними существами.`,
                    examples: ["Озеро, где обитает дух воды"]
                },
                {
                    title: "Опасные зоны",
                    description: `Леса с агрессивной флорой или фауной. Радиоактивные пустоши, магические аномалии. Места обитания монстров.`,
                    examples: ["Лес с пауками-убийцами"]
                },
                {
                    title: "Фантастические зоны",
                    description: `Леса с деревьями, которые поют. Озера, в которых скрыта другая реальность. Поляны, изменяющие время.`,
                    examples: ["Лес, где каждое дерево имеет свой голос"]
                }]
        }
    ],

    prompt: {
        component: {
            list: "Сгенерируй компоненты сеттинга для описания природы мира истории.",
            single: "Сгенерируй компонент сеттинга для описания природы мира истории.",
            extend: "Расскажи подробнее о природе мира истории и разбей на абзацы.",
        },
        element: {
            list: "Сгенерируй элементы сеттинга для описания компонента природы мира истории.",
            single: "Сгенерируй элемент сеттинга для описания компонента природы мира истории.",
            extend: "Расскажи подробнее о природе мира истории и разбей на абзацы."
        },
        lore: {
            list: "Создай элементы лора на основе этого элемента природы. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента экономики. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора природы и разбей на абзацы."
        }

    }
}